<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Serviço adicional</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div>
    <div class="mt-6 mb-4">
      <mat-card class="card-style px-4 py-6 mb-4">
        <div class="flex justify-between gap-2 mt-4">
          <div class="w-3/12"><strong>Tg:</strong> {{ data.codigoTg }}</div>
          <div class="w-3/12">
            <strong>Início:</strong> {{ data.dataInicio }} <strong>Fim:</strong> {{ data.dataFinal }}
          </div>
        </div>
        <div class="flex justify-between gap-2 mt-4">
          <div class="w-6/12">
            <strong>Evento:</strong>
            {{ data.nomeEvento }}
          </div>
          <div class="w-6/12">
            <strong
            >{{
                data.nomeSubCliente && data.nomeSubCliente != ''
                  ? 'Subcliente'
                  : 'Cliente'
              }}:</strong
            >
            {{
              data.nomeSubCliente && data.nomeSubCliente != ''
                ? data.nomeSubCliente
                : data.nomeCliente
            }}
          </div>
        </div>
        <div class="flex justify-between gap-2 mt-4">
          <div class="w-4/12">
            <strong>Solicitante:</strong> {{ data.nomeConsultor }}
          </div>
          <div class="w-4/12">
            <strong>Consultor comercial:</strong> {{ data.consultorComercial }}
          </div>
          <div class="w-4/12">
            <strong>Consultor operacional:</strong> {{ data.consultorOperacional }}
          </div>        </div>
      </mat-card>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Pesquisa </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <form-search-os-new
            [search]="inputSearch"
            (responseSearch)="search($event)"
          />
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    </div>
    <div class="mt-4">
      <div>
        @if (!loading) {
          <div>
            <table-list-os
              [dataSource]="itemsList"
              [columns]="columns"
              (selectItem)="editItem($event)"
              (replierItem)="replierItem($event)"
              (deleteItem)="deleteItem($event)"
            />
            @if (itemsList.length > 0) {
              <mat-paginator
                [length]="numberRows"
                [pageSize]="rows"
                [pageIndex]="page - 1"
                [pageSizeOptions]="[5, 10, 20, 30]"
                (page)="onPageEvent($event)"
              >
              </mat-paginator>
            }
          </div>
        } @else {
          <div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
      </div>
    </div>
  </div>
</mat-card>
